import { SET_PRODUTO, SET_LOADING } from './mutation-types'
import produtoService from '@/services/produtos/produtoService'

export default {
    fetchById({ commit }, { produtoId, successCallback, errorCallback }) {
        commit(SET_LOADING, true)
        produtoService.fetchById(produtoId)
            .then(res => {
                commit(SET_PRODUTO, res.data)
                successCallback && successCallback();
            })
            .catch(error => errorCallback && errorCallback())
            .finally(res => commit(SET_LOADING, false))
    },
    limparDetalhes({ commit }) {
        commit(SET_PRODUTO, {})
    }
}